import { Box, RadioGroup } from "@outschool/backpack";
import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";
import React from "react";

import { useCreditFilterOptions } from "../../CreditFilter";
import { Filter } from "../Filter";
import { ListingChildFilterProps } from "./ListingFilters";

type CreditFilterProps = ListingChildFilterProps & {
  isCourse?: boolean;
};

type SearchFiltersTypeKey = keyof SearchFiltersType;

export function CreditFilter({
  searchFilters,
  onChange,
  isCourse = false
}: CreditFilterProps) {
  const { t } = useTranslation(
    "client\\components\\search\\mobile\\filters\\CreditFilter"
  );

  const priceCreditsOptions = useCreditFilterOptions(isCourse);
  const [minValueKey, maxValueKey]: [
    SearchFiltersTypeKey,
    SearchFiltersTypeKey
  ] = isCourse
    ? ["priceCreditsPerCourseMin", "priceCreditsPerCourseMax"]
    : ["priceCreditsPerMeetingMin", "priceCreditsPerMeetingMax"];

  const priceCreditsValue = {
    [minValueKey]: searchFilters[minValueKey] || null,
    [maxValueKey]: searchFilters[maxValueKey] || null
  };

  return (
    <Filter
      showTopBorder={false}
      sectionTitle={isCourse ? t("Cost per course") : t("Cost per class")}
    >
      <Box
        sx={{
          padding: "12px 24px 24px 0px"
        }}
      >
        <RadioGroup
          name="price"
          options={priceCreditsOptions}
          value={JSON.stringify(priceCreditsValue)}
          onChange={(_e: any, v: string) => {
            const parsedValue = JSON.parse(v);
            onChange?.(parsedValue);
          }}
        />
      </Box>
    </Filter>
  );
}
